import MedicalRecordItem from './medical-record-item';

export default MedicalRecordItem;
